import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {FormsModule} from '@angular/forms';

import {SharedModule} from "../shared/shared.module";
import {MainComponent} from "./main.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {EditorComponent} from "./editor/editor.component";
import {GrapeComponent} from "./grape/grape.component";
import {WidgetsComponent} from "./widgets/widgets.component";
import {MailingsComponent} from "./mailings/mailings.component";
import {MailingModalComponent} from "./mailings/modals/mailing.modal.component";
import {WidgetModalComponent} from "./widgets/modals/widget.modal.component";
import {HeaderComponent} from "./header/header.component";
import {NavComponent} from "./nav/nav.component";
import {WidgetTypeComponent} from './editor/modals/widget-type.modal.component';
import {TimetableComponent} from './timetable/timetable.component';
import {UsersComponent} from './users/users.component';
import {UserModalComponent} from "./users/modals/user.modal.component";

import {PaginationComponent} from './pagination/pagination.component';

@NgModule({
    imports: [
        RouterModule.forChild(
            [
                {
                    path: 'dashboard',
                    component: DashboardComponent
                },
                {
                    path: 'editor/:id/:lang',
                    component: EditorComponent
                },
                {
                    path: 'mailings',
                    component: MailingsComponent
                },
                {
                    path: 'grape/:id',
                    component: GrapeComponent
                },
                {
                    path: 'widgets',
                    component: WidgetsComponent
                },
                {
                    path: 'timetable',
                    component: TimetableComponent
                },
                {
                    path: 'users',
                    component: UsersComponent
                }
                // {
                //     path: 'mailing',
                //     component: MailingComponent,
                //     loadChildren: './mailing/mailing.module#MailingModule'

                // },
            ]
        ),
        SharedModule,
        FormsModule
//        MailingModule
    ],
    exports: [
        SharedModule,
        RouterModule
    ],
    declarations: [
        MainComponent,
        DashboardComponent,
        EditorComponent,
        WidgetsComponent,
        MailingsComponent,
        MailingModalComponent,
        WidgetModalComponent,
        GrapeComponent,
        WidgetTypeComponent,
        HeaderComponent,
        NavComponent,
        TimetableComponent,
        PaginationComponent,
        UsersComponent,
        UserModalComponent
    ],
    providers: []
})
export class MainModule {
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/main.module.ts